import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 履歴処理区分のENUM */
enum HistoryProcessType {
  laStartRegistration = '3',
  laCancelBeforeMaturity = '5',
  laContractInfoChange = '4',
  laArticleInfoChange = '1',
  reLeaseAndContractExpired = '6',
}

const nameConfig = {
  laArticleInfoChange: new Map([[Locale.ja, 'リース物件情報変更']]),
  laStartRegistration: new Map([[Locale.ja, 'リース開始登録']]),
  laContractInfoChange: new Map([[Locale.ja, 'リース契約情報変更']]),
  laCancelBeforeMaturity: new Map([[Locale.ja, 'リース中途解約']]),
  reLeaseAndContractExpired: new Map([[Locale.ja, '再リース及び契約満了']]),
};

const toEnum = rawValueToEnum(HistoryProcessType, HistoryProcessType.laStartRegistration);
const toDisplay = enumToName(HistoryProcessType, nameConfig);
const toDisplayWithPrefix = enumToName(HistoryProcessType, nameConfig, { prefix: true });

export const historyProcessType = {
  enum: HistoryProcessType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { HistoryProcessType };
